import { render, staticRenderFns } from "./BranchesToBeAssignedComponent.vue?vue&type=template&id=0bcf0cca&scoped=true"
import script from "./BranchesToBeAssignedComponent.vue?vue&type=script&lang=js"
export * from "./BranchesToBeAssignedComponent.vue?vue&type=script&lang=js"
import style0 from "./BranchesToBeAssignedComponent.vue?vue&type=style&index=0&id=0bcf0cca&prod&scoped=true&lang=css"
import style1 from "./BranchesToBeAssignedComponent.vue?vue&type=style&index=1&id=0bcf0cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf0cca",
  null
  
)

export default component.exports